/**
 * SUPABASE RUNTIME CONFIGURATION
 *
 * Shares the same Supabase project as the Portal staff/client app — this is
 * a separate Magic Patterns design, so the values are held here directly
 * rather than imported across projects. Both are browser-public by design:
 * the URL is the project's address and the key is the *publishable* (anon)
 * key, which is intended to ship in client code. A service-role or secret
 * key must NEVER be placed here.
 */

const env = ((import.meta as unknown as { env?: Record<string, string> }).env ?? {}) as Record<
  string,
  string | undefined
>

const FALLBACK_URL = 'https://fdyfqzqogibrsqxueeaj.supabase.co'
const FALLBACK_PUBLISHABLE_KEY = 'sb_publishable_tQVieGED5whFw1z9ynJMuQ_4jVN7T3h'

export const SUPABASE_URL = (env.VITE_SUPABASE_URL || FALLBACK_URL).trim()

export const SUPABASE_PUBLISHABLE_KEY = (
  env.VITE_SUPABASE_PUBLISHABLE_KEY || FALLBACK_PUBLISHABLE_KEY
).trim()
